---
nb:
  asset_comments:
    create_title: Ny kommentar
    overlap_current_month: Overlappende kommentar for inneværende måned i inneværende år
    overlap_current_quarter: Overlappende kommentar for inneværende kvartal i inneværende år
    overlap_current_year: Overlappende kommentar for inneværende år
    title: Kommentarer
